import http from './public'

export default {
    // 获取购物车列表
    cartItemList: (params) => {
        return http.fetchGet('cartItemList', params)
    },
    // 获取购物车列表 测试
    cartItemList2: (params) => {
        return http.fetchGet('cartItemList2', params)
    },

    // 获取地址 
    address: (params) => {
        return http.fetchGet('address', params)
    },
    // 添加订单
    orderAdd: (params) => {
        return http.fetchPost('orderAdd', params)
    },
    // 添加订单测试
    orderAdd2: (params) => {
        return http.fetchPost('orderAdd2', params)
    },
    // 添加订单测试
    orderAddTest: (params) => {
        return http.fetchPost('orderAddTest', params)
    },
}